import '../styles/global.scss';
import './components/menu.js';
import '../js-new/components/footer-show-more.js';
import './components/header-mob-accordion';
import './components/cookies';
import '../js-new/components/footer-show-more.js';
import '../js-new/components/bottom-navbar';
import ScreenSizeDetector from 'screen-size-detector';

// const headerWrapper = document.querySelector('.header__wrapper');
// const header = document.querySelector('.header');
import '../js-new/components/categories-filter';

window.glblMessages = {
  "en": {
    "yesBtn": "Yes",
    "noBtn": "No",
    "adultContentMsg": "Are you 18 years old?",
    "nextArticle": "The next news",
    "readMore": "Read more",
    "expandBtn": "Expand",
    "collapseBtn": "Collapse",
  },
  "ru": {
    "yesBtn": "Да",
    "noBtn": "Нет",
    "adultContentMsg": "Вам уже исполнилось 18 лет?",
    "nextArticle": "Следующая новость",
    "readMore": "Читать далее",
    "expandBtn": "Развернуть",
    "collapseBtn": "Свернуть",
  },
  "uk": {
    "yesBtn": "Так",
    "noBtn": "Ні",
    "adultContentMsg": "Вам вже є 18 років?",
    "nextArticle": "Наступна новина",
    "readMore": "Читати більше",
    "expandBtn": "Розгорнути",
    "collapseBtn": "Згорнути",
  }
}

// const makeHeaderFixed = function (e) {
//   headerWrapper.style.position = 'fixed';
//   headerWrapper.style.boxShadow = '0px 3px 6px rgba(0, 0, 0, 0.16)';
//   headerWrapper.style.top = '0';
//   if (window.scrollY < 3)
//     headerWrapper.style.boxShadow = 'none';
//   headerWrapper.style.top = '-5px';
//   header.style.marginTop = '61px';
// }

// const defaultOptions = {
//   widthDefinitions: { // Width definitions object. Can be overwritten, added or removed
//     tablet: {
//       min: 0,
//       max: 768,
//       inclusion: "[]",
//       onEnter: () => {
//         window.addEventListener('scroll', makeHeaderFixed);
//       },
//       onLeave: () => {
//         window.removeEventListener('scroll', makeHeaderFixed);
//         headerWrapper.style.position = 'relative';
//         headerWrapper.style.boxShadow = 'none';
//         header.style.marginTop = '0';
//       },
//     },
//   },
// };

// new ScreenSizeDetector(defaultOptions);

function getDomain() {
  const hostnameArray = window.location.hostname.split('.')
  const numberOfSubdomains = hostnameArray.length - 2
  return hostnameArray.length === 2 ? window.location.hostname : hostnameArray.slice(numberOfSubdomains).join('.')
}

// window.addEventListener("beforeunload", function(e) {
//   document.cookie = `origin=${window.location.href}; path=/; domain=${getDomain()};`
// }); 

window.addEventListener("pagehide", function (e) {
  document.cookie = `origin=${window.location.href}; path=/; domain=${getDomain()};`
});

const seoText = document.querySelector('.seo-text');

if (seoText) {
  const btn = document.querySelector('.seo-text__show-more')
  btn?.addEventListener('click', () => {
    seoText.classList.add('seo-text_full');
  })
}

// HANDLE HOT-LINE CLOSE
const hotLineEl = document.querySelector('.hot-line');
const hotLineElWrapper = document.querySelector('.hot-line-wrapper');
const hotLineElCloseBtn = document.querySelector('.hot-line__close');

hotLineElCloseBtn?.addEventListener('click', () => {
  hotLineElWrapper.classList.add('hot-line-wrapper_closed');
  // localStorage.setItem('hotLineClosed', true);
});


// HANDLE HEADER SCROLL
const handleHeaderScroll = () => {
  let startScrollPos = 0;
  const hasWarElements = hotLineElWrapper?.previousElementSibling?.classList.contains('war-elements');
  if (hasWarElements && window.innerWidth > 1024) {
    startScrollPos = 30;
  } else if (window.innerWidth <= 1024) {
    startScrollPos = 22;
  }
  if (hasWarElements && window.innerWidth <= 1024) {
    startScrollPos = 54;
  }
  if (window.scrollY > startScrollPos) {
    hotLineEl?.classList.add('hot-line_scrolled');
  } else {
    hotLineEl?.classList?.remove('hot-line_scrolled');
  }
}

const handleHeaderActive = () => {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (window.scrollY > 5) {
    headerWrapper?.classList.add('header-wrapper_active');
  } else {
    headerWrapper?.classList.remove('header-wrapper_active');
  }
}

window.addEventListener('scroll', () => {
  handleHeaderScroll();
  if (window.innerWidth < 1024) {
    handleHeaderActive();
  }
});
handleHeaderScroll();

const languagesListBtn = document.querySelector('.languages-list__btn');
const headerPopup = document.querySelector('.header-popup');
const burgerMenuBtn = document.querySelector('.hamburger-menu');
const languagesList = languagesListBtn.nextElementSibling;
languagesListBtn.addEventListener('click', () => {
  languagesList.classList.toggle('hidden');
  headerPopup.classList.remove('header-popup_active');
  burgerMenuBtn.classList.remove('hamburger-menu_active');
});
languagesList.addEventListener('click', (e) => {
  languagesList.classList.add('hidden');
});

document.body.addEventListener('click', (e) => {
  if (!e.target.closest('.languages-list')) {
    languagesList.classList.add('hidden');
  }
});